import { createStyles, makeStyles } from '@hawkins/styles';
export function badgeDropdownStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the `Badge`. */
        badge: {
            cursor: 'pointer',
        },
        /** Class name to apply to the caret */
        caret: {},
        /** Class name of the `Badge` when the component is disabled. */
        badgeDisabled: {
            cursor: 'not-allowed',
        },
        /** Class applied to the end adornment of the `Badge` */
        badgeEndAdornment: {
            '& $caret': {
                height: hawkinsVariables.sizings.size1,
                display: 'block',
            },
        },
    });
}
export var useBadgeDropdownStyles = makeStyles(badgeDropdownStyles, { name: 'Hawkins-BadgeDropdown' });
